import React from 'react';
import { arrayOf, string, number, shape } from 'prop-types';
import { compose, setDisplayName, setPropTypes } from 'react-recompose';

import { Statistic } from 'semantic-ui-react';

import { fetchOrganizationUsersStats } from './operations';
import withReduxDataLoading, { withLoadingBranch } from '~/views/enhancers/withReduxDataLoading';

import Section from '~/views/common/Section';


export const UsersStats = ({ stats = [] }) => (
    <Section name="Users Statistics">
        <Statistic.Group>
            <Statistic
                value={stats ? stats.reduce((total, { count }) => total + count, 0) : null}
                label="total"
                color="green"
            />
            { stats && stats.map(({ role, count }) => (
                <Statistic
                    key={role}
                    value={count}
                    label={role}
                />
            )) }
        </Statistic.Group>
    </Section>
);

UsersStats.propTypes = {
    stats: arrayOf(shape({
        role: string.isRequired,
        count: number.isRequired,
    }).isRequired),
};


export default compose(
    setDisplayName('SSOContainer'),
    setPropTypes({
        id: string.isRequired,
    }),
    withReduxDataLoading({
        name: 'fetchOrganizationUsersStats',
        operation: ({ id }) => fetchOrganizationUsersStats(id),
        dataName: 'stats',
    }),
    withLoadingBranch,
)(UsersStats);
